import { Box } from '@wix/design-system'
import React from 'react'

import { FooterControls, FooterControlsSpacerHeight, FooterControlsType } from '../FooterControls'
import WixLogo from '../icons/WixLogo.svg'
import { wixIntrosTemplateDataHooks as dataHooks } from './WixIntrosTemplate.dataHooks'
import s from './WixIntrosTemplate.scss'

type WixIntrosTemplateProps = {
  children: React.ReactNode
  withLogo?: boolean
  back?: string
  skip?: string
  onBack?: () => void
  onSkip?: () => void
}

export const WixIntrosTemplate: React.FC<WixIntrosTemplateProps> = props => (
  <Box
    direction="vertical"
    align="center"
    minHeight="100vh"
    padding="18vh 18vw"
    backgroundColor="#F6F7F9"
    className={s.WixIntrosTemplate}
  >
    {(props.withLogo && <WixLogo data-hook={dataHooks.logo()} className={s.WixIntrosTemplate__logo} />) || null}
    {props.children}
    {((props.back || props.skip) && (
      <FooterControls
        dataHook={dataHooks.footerControls()}
        backText={props.back}
        skipText={props.skip}
        backOnClick={props.onBack}
        skipOnClick={props.onSkip}
        isVisible
        spacerHeight={FooterControlsSpacerHeight.NONE}
        type={FooterControlsType.TRANSPARENT}
      />
    )) ||
      null}
  </Box>
)
